import { z } from "zod/v4";

export const TauriEventSchema = z.union([
	z.object({
		type: z.literal("deeplink.opened"),
		payload: z.object({
			path: z.string(),
		}),
	}),
]);

export type TauriEvent = z.infer<typeof TauriEventSchema>;
